import { render, staticRenderFns } from "./TDialogCard.vue?vue&type=template&id=06ca533c"
import script from "./TDialogCard.vue?vue&type=script&lang=js"
export * from "./TDialogCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports